import { Modal, Text } from '@belong/ui';
import { BLOG_CONTENT_STRINGS } from '../../blog.strings';
import { ContentTableItems } from '../content-table-items/content-table-items';
import type { ContentTableItem } from '../content-table-items/content-table-items';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  tableOfContents: ContentTableItem[];
};

export function ContentSelectModal({
  isOpen,
  onDismiss,
  tableOfContents,
}: Props) {
  return (
    <Modal
      size="fullScreen"
      isOpen={isOpen}
      onDismiss={onDismiss}
      name="blog_content_select"
    >
      <div className="py-2sm">
        <Text className="mb-lg px-sm" fontWeight="semibold">
          {BLOG_CONTENT_STRINGS.tableContents}
        </Text>
        <div className="px-xl">
          <ContentTableItems items={tableOfContents} onDismiss={onDismiss} />
        </div>
      </div>
    </Modal>
  );
}
